import React, { Component } from 'react';

import style from './ChapterImage.module.scss';

class ChapterImage extends Component {
  render() {
    const { imagePath, imageAlt, index } = this.props;

    return (
      <div className={`chapter-image-wrap ${style.chapterImageWrapper}`}>
        <div
          className={`chapter-image-wrap--reverse ${
            style.chapterImageWrapperReverse
          }`}
        >
          <img
            className={`chapter-image ${style.introImage}`}
            src={`${this.props.imagePath}`}
            alt={this.props.imageAlt}
          />
        </div>
      </div>
    );
  }
}

export default ChapterImage;



// WEBPACK FOOTER //
// ./src/components/exhibition/ChapterImage.js